module.exports = __webpack_public_path__ + "img/logo-emil-frey-use-case.25b283f6.png";